import { Box, styled } from '@/theme/index';

export const StyledCameraIconContainer = styled(Box)(({ theme }) => ({
  padding: 2,
  height: 40,
  width: 40,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '100%',
  backgroundColor: 'white',
  border: `2px solid ${theme.palette.primary.main}`,

  '& svg': {
    color: 'theme.palette.primary.main',
  },

  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: 'white',

    '& svg': {
      color: 'white',
    },
  },
}));
